module.exports = __webpack_public_path__ + "img/37560-108.c4bae79e.jpg";